/**
 * Ce fichier contrôle les pages v2 de l'op1euro
 */


/**
 * Faire swiper les images dans la galeries des produits
 */
const swipeImageProduct = () => {

    const el = document.querySelectorAll('#presentation-produit #images-produit-min a');
    const imageLargeHTMLElement = document.querySelector('#presentation-produit #image-produit-large img');


    el.forEach((imageAElement) => {

        imageAElement.addEventListener('mouseover', () => {
            el.forEach(a => a.classList.remove('border-black')) // Suppression des bordures noir

            // Changement de la grande image + ajout de la bordure noir à l'image active
            const imgLarge = imageAElement.getAttribute('data-image-large');
            imageLargeHTMLElement.setAttribute('src', imgLarge);
            imageAElement.classList.add('border-black')
        })
    })
}


swipeImageProduct()


const openFancybox = () => {

    const el = document.querySelector('[data-fancybox-open]');
    if(el !== null)
    {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('[data-fancybox="gallery"]').click();
        })
    }

}

openFancybox();
